<template>
  <div>
    <div class="awards_submission_rating ma-0" style="display: flex; align-items: center;">
      <template v-if="parseInt(submission['rating'], 10) >= 1">
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-chip :color="`awards_rated_${rating}`" text-color="white" v-on="on" class="mx-0">
              <span class="subheading font-weight-bold">{{ rating }}</span>
              <v-icon right class="ml-1 notranslate">star</v-icon>
            </v-chip>
          </template>
          <span>{{ $t(`awards.rated_${rating}`) }}</span>
        </v-tooltip>
        <v-tooltip v-if="merit" top>
          <template v-slot:activator="{ on }">
            <v-icon right class="ml-1 notranslate" :color="`awards_rated_${rating}`" v-on="on">
              {{ submission['rating'] >= 9 ? 'fa-award' : 'fa-medal' }}
            </v-icon>
          </template>
          <span>{{ $t(merit+'_description.'+submission_method) }}</span>
        </v-tooltip>
      </template>
      <v-chip v-else label outline>
        {{ $t('disqualified') }}
      </v-chip>
    </div>
  </div>
</template>

<script>
import VChip from 'vuetify/es5/components/VChip/VChip'
import VTooltip from 'vuetify/es5/components/VTooltip/VTooltip'
export default {
  name: 'AwardsSubmissionRating',
  components: { VChip, VTooltip },
  props: {
    submission: {
      type: Object,
      required: true
    },
    submission_method: {
      type: String,
      required: true
    },
    has_comment: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      rating: 0,
      merit: ''
    }
  },
  created () {
    this.rating = Math.max(5, this.submission['rating'])
    if (this.submission['rating'] >= 9) {
      this.merit = 'award'
    } else if (this.submission['rating'] === 8) {
      this.merit = 'honorable_mention'
    } else {
      this.merit = ''
    }
  }
}
</script>

<style scoped lang="scss">

</style>

<i18n>
  {
  "en": {
  "disqualified": "Disqualified",
  "honorable_mention_description": {
  "image_upload": "This photo received an \"honorable mention\", it came very close!",
  "video_link": "This film received an \"honorable mention\", it came very close!",
  "photo_album": "This collection received an \"honorable mention\", it came very close!"
  },
  "award_description": {
  "image_upload": "This photo was awarded, it has reached the top! Congratulations.",
  "video_link": "This film was awarded, it has reached the top! Congratulations.",
  "photo_album": "This collection was awarded, it has reached the top! Congratulations."
  }
  },
  "pt": {
  "disqualified": "Desclassificado",
  "honorable_mention_description": {
  "image_upload": "Esta foto recebeu uma \"menção honrosa\", ela chegou muito perto!",
  "video_link": "Este filme recebeu uma \"menção honrosa\", ele chegou muito perto!",
  "photo_album": "Esta coleção recebeu uma \"menção honrosa\", ela chegou muito perto!"
  },
  "award_description": {
  "image_upload": "Esta foto foi premiada, ela chegou ao topo! Parabéns.",
  "video_link": "Este filme foi premiado, ele chegou ao topo! Parabéns.",
  "photo_album": "Esta coleção foi premiada, ela chegou ao topo! Parabéns."
  }
  }
  }
</i18n>
